// extracted by mini-css-extract-plugin
module.exports = {"institution":"index_institution__11fqS"};